module.exports = __webpack_public_path__ + "img/12.f5ab5c54.svg";